import '@/shared/plugins/dayjs';
import '@/shared/plugins/vue-dompurify-html';
import '@/shared/plugins/vue-enums';
import '@/shared/plugins/vue-accessibility-focus';
import deferredPlugin from '@/shared/plugins/deferred';
import servicesPlugin from '@/shared/plugins/services';
import spinnerPlugin from '@/shared/plugins/spinner';
import statsPlugin from '@/shared/plugins/stats';
import storagePlugin from '@/shared/plugins/storage';
import windowPlugin from '@/shared/plugins/window';
import chartbeatPlugin from '@/shared/plugins/chartbeat';
import freewheelPlugin from '@/shared/plugins/freewheel';
import gtmPlugin from '@/shared/plugins/gtm';
import gemiusPlugin from '@/shared/plugins/gemius/audience';
import gemiusStreamPlugin from '@/shared/plugins/gemius/stream';
import ipressoPlugin from '@/shared/plugins/ipresso';
import playerPlugin from '@/shared/plugins/player';
import trackingPlugin from '@/shared/plugins/tracking';
import resourcesPlugin from '@/shared/plugins/resources';
import onetrustPlugin from './onetrust';
import routerPlugin from './router';
import sdkPlugin from './sdk';
import initPlugin from './init';

export default [
  deferredPlugin,
  servicesPlugin,
  spinnerPlugin,
  statsPlugin,
  storagePlugin,
  windowPlugin,
  routerPlugin,
  onetrustPlugin,
  chartbeatPlugin,
  freewheelPlugin,
  gtmPlugin,
  gemiusPlugin,
  gemiusStreamPlugin,
  ipressoPlugin,
  playerPlugin,
  trackingPlugin,
  resourcesPlugin,
  sdkPlugin,
  initPlugin,
];
